import { defineFcm } from '../shared/factory';

export const FCM_CREAM_CHIP_IN_VALUES = defineFcm('cream_chip_in_values').asNumber().withDefault(undefined).toConfig({
	owner: 'TBD',
	scope: 'corgi-front-end',
	context: 'PSF promote or share page',
	description:
		'Defines which amount to set in the "chip in" button. Should be in the country\'s currency (e.g. "5" for "5 euros")',
	import: false,
});
